import _debounce from 'lodash/debounce';

function scaleElementsToFitContainer(elements, aspectRatioAttribute) {
    elements.forEach((element) => {
        const aspectRatioString = element.getAttribute(aspectRatioAttribute) || '16/9';
        const containerWidth = element.parentElement.getBoundingClientRect().width;

        const aspectRatio = {
            width: parseInt(aspectRatioString.split('/')[0], 10),
            height: parseInt(aspectRatioString.split('/')[1], 10),
        };

        element.style.width = `${containerWidth}px`;
        element.style.height = `${(containerWidth / aspectRatio.width) * aspectRatio.height}px`;
    });
}

const scaleToFitContainers = (
    elementSelector = '[data-scale-to-fit-container]',
    aspectRatioAttribute = 'data-scale-with-aspect-ratio'
) => {
    const elements = Array.from(document.querySelectorAll(elementSelector));

    scaleElementsToFitContainer(elements, aspectRatioAttribute);

    window.addEventListener(
        'resize',
        _debounce(() => {
            scaleElementsToFitContainer(elements, aspectRatioAttribute);
        }, 500)
    );
};

export { scaleToFitContainers as default };
